<script setup lang="ts">
import LeftMenu from '~/component/menu/LeftMenu.vue'
import HeaderComp from '~/component/HeaderComp.vue'
import BottomFix from '~/component/BottomFix.vue'
import TermsModal from '~/component/TermsModal.vue'
import SavedPassageLoadLayer from '~/component/data/SavedPassageLoadLayer.vue'
import FolderDetailLayer from '~/component/data/FolderDetailLayer.vue'
import NewPassageInputLayer from '~/component/data/NewPassageInputLayer.vue'
import DataPreviewLayer from '~/component/data/DataPreviewLayer.vue'
import DropsPackageLayer from '~/component/point/DropsPackageLayer.vue'
import Pagination from '~/component/Pagination.vue'
import PassageDetailLayer from '~/component/passageStorage/PassageDetailLayer.vue'
import CreateNewFolderLayer from '~/component/passageStorage/CreateNewFolderLayer.vue'
import PassageInputLayer from '~/component/passageStorage/PassageInputLayer.vue'
import MoveToFolder from '~/component/passageStorage/MoveToFolder.vue'

const dataLayerPopup = useDataLayerPopup()
const pointPopup = usePoint()
const passageStorage = usePassageStorage()
const pagination = usePagination()

// bottomFix 숨기기
const { $bottomFix } = useNuxtApp()
onMounted(() => {
  $bottomFix.hide()
})
</script>
<template>
  <!-- #wrap -->
  <div id="wrap">
    <LeftMenu />
    <hr />
    <HeaderComp />
    <slot></slot>
    <hr />

    <!-- .pagingArea -->
    <Pagination v-if="pagination.state.value.isVisible" />
    <!-- .pagingArea -->

    <BottomFix />
    <TermsModal />

    <!-- Data Layer Popups -->
    <SavedPassageLoadLayer
      v-if="dataLayerPopup.state.value.savedPassageLoad.isVisible"
    />
    <FolderDetailLayer
      v-if="dataLayerPopup.state.value.folderDetail.isVisible"
      :folder-id="dataLayerPopup.state.value.folderDetail.folderId"
      :folder-name="dataLayerPopup.state.value.folderDetail.folderName"
      :passage-count="dataLayerPopup.state.value.folderDetail.passageCount"
    />
    <NewPassageInputLayer
      v-if="dataLayerPopup.state.value.newPassageInput.isVisible"
    />
    <DataPreviewLayer v-if="dataLayerPopup.state.value.dataPreview.isVisible" />

    <!-- Drops (Point) Layer Popups -->
    <DropsPackageLayer v-if="pointPopup.state.value.isVisible" />

    <!-- 지문보관함 Layer Popups -->
    <PassageDetailLayer
      v-if="passageStorage.state.value.passageDetail.isVisible"
    />
    <PassageInputLayer
      v-if="passageStorage.state.value.passageInput.isVisible"
    />
    <CreateNewFolderLayer
      v-if="passageStorage.state.value.createFolder.isVisible"
    />
    <MoveToFolder v-if="passageStorage.state.value.moveToFolder.isVisible" />
  </div>
  <!-- /#wrap -->
</template>
<style>
@import '@/assets/css/style.css';
</style>
